<div class="video-container">
  <video
    *ngIf="videoUrl; else placeholder"
    [src]="videoUrl"
    controls
    width="640"
    height="360"
  >
    Your browser does not support video.
  </video>

  <ng-template #placeholder>
    <div class="placeholder">
      <p>Recording will appear here</p>
      <button (click)="loadVideo()" [disabled]="isLoading">
        {{ isLoading ? 'Loading...' : 'Load Recording' }}
      </button>
    </div>
  </ng-template>

  <div *ngIf="error" class="error">
    Error: {{ error }}
  </div>
</div>

{{ videoUrl }}